import { ComponentProps, ReactNode, useContext } from 'react';

import { twMerge } from 'tailwind-merge';

import { ScrollArea } from '../../ScrollArea';

import { ModalContext, SIZES } from './context';

interface ModalBodyProps extends ComponentProps<typeof ScrollArea> {
  readonly children?: ReactNode;
  readonly className?: string;
}

function ModalBody({ children, className, ...props }: ModalBodyProps) {
  const { size } = useContext(ModalContext);

  return (
    <ScrollArea className={twMerge(SIZES[size].body, className)} {...props} asChild>
      {children}
    </ScrollArea>
  );
}

export { ModalBody };
